//pc端和移动端需要共用一套数据源，pc插件和移动端的数据结构不一致，需要自己统一数据源，造出不同的数据结构。
import {AreaTree} from './areaTree.js';
import {AreaFlat} from './areaFlat.js';
import {AreaFlatReverse} from './areaFlatReverse.js'

/**
 * codeToText code转换成文本
 * @param code Array[省code,市code,区code]
 * @returns {*}
 *
 */
function CodeToText(code) {
    return [AreaFlat.province_list[code[0]] || '', AreaFlat.city_list[code[1]] || '', AreaFlat.county_list[code[2]] || '']
}

/**
 * textToCode 文本转换为code
 * @param area Array[省,市,区]
 */
function TextToCode(area) {
    return [AreaFlatReverse.province_list[area[0]] || '', AreaFlatReverse.city_list[area[1]] || '', AreaFlatReverse.county_list[area[2]] || '']
}

export default {
    AreaTree,
    AreaFlat,
    CodeToText,
    TextToCode
}

